import _ from 'lodash';
//reducers
import { useAppSelector } from 'hooks/redux.hooks';
import { getCurrencies } from 'state/reducers/global.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
//theme
import { NavigationBack } from 'theme/elements/Headers';
import { PageHeaderCard } from 'theme/elements/Cards';
//components
import { FormButton } from 'theme/elements/Buttons';
//MUI
import { Typography, Stack, Button, Box, useTheme } from '@mui/material';
//constants
import { Beneficiary } from 'constants/beneficiary.constants';
import { getFormattedNumber } from 'utils';

export default function Header(props: { refund?: any }) {
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);
  const Currencies = _.keyBy(useAppSelector(getCurrencies), function (o) {
    return o.id;
  });

  return (
    <PageHeaderCard>
      <Stack spacing={2} direction="row" justifyContent={'space-between'}>
        <Box>
          <Stack spacing={2} direction="row">
            <Typography variant="h4" display={{ xs: 'none', sm: 'block' }}>
              <NavigationBack />
            </Typography>
            <Stack>
              <Typography variant="h3">
                {_.has(Currencies, props?.refund?.currencyId)
                  ? _.get(Currencies, props?.refund?.currencyId).symbol
                  : ''}
                {getFormattedNumber(props?.refund?.amount)}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </PageHeaderCard>
  );
}
